module.exports = __webpack_public_path__ + "static/media/mitsubishi.e326364d.png";